module.exports = __webpack_public_path__ + "static/img/02.6f7414b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/02.png
// module id = DCNY
// module chunks = 1